import { useTranslation } from '@/shared/hooks/useTranslation'
import { Field, TextField } from '@/shared/ui/Form'

/** Campo de recuperação: apenas o e-mail para onde vai o código. */
export function ForgotPasswordFields() {
  const { t } = useTranslation()

  return (
    <Field name="email">
      <Field.Label>{t('auth.email', {}, { fallback: 'E-mail' })}</Field.Label>
      <Field.Control>
        <TextField type="email" autoComplete="email" inputMode="email" />
      </Field.Control>
      <Field.Error />
    </Field>
  )
}
